import config from '../../../proxyConfig'

export const LOGIN = 'app/authentication/LOGIN'
export const LOGOUT = 'app/authentication/LOGOUT'
export const SET_USER = 'app/authentication/SET_USER'
export const SHOW_MY_PROJECTS = 'app/authentication/SHOW_MY_PROJECTS'

export const samlLoginLink = {
  development: 'https://dev.docu-tools.com/idpSelection',
  staging: 'https://dev.docu-tools.com/idpSelection',
  'production-ready': 'https://saml.docu.solutions',
  production: 'https://saml.docu.solutions',
  strabag: 'https://saml.docutools.strabag.io'
}

export const authorization = `Basic ${btoa(`${config.clientId}:${config.clientSecret}`)}`
